export default [
  {
    name: 'my-account',
    path: '/my-account',
    locales: {
      es: '/mi-cuenta',
      pt: '/minha-conta',
    },
  },
  {
    name: 'contactPreferences',
    path: '/contact-preferences',
    locales: {
      es: '/preferencias-contacto',
      pt: '/preferencias-contato',
    },
  },
  {
    name: 'selfExclusion',
    path: '/self-exclusion',
    locales: {
      es: '/auto-exclusion',
      pt: '/auto-exclusao',
    },
  },
  {
    name: 'wager-limits',
    path: '/wager-limits',
    locales: {
      es: '/limites-apuestas',
      pt: '/limites-apostas',
    },
  },
  {
    name: 'history',
    path: '/history',
    locales: {
      es: '/historial',
      pt: '/historico',
    },
  },
  {
    name: 'contact',
    path: '/contact-us',
    locales: {
      es: '/contactenos',
      pt: '/contactenos',
    },
  },
];
